"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var UserCircle = function UserCircle(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M20,4 C28.832,4 36,11.168 36,20 C36,28.832 28.832,36 20,36 C11.168,36 4,28.832 4,20 C4,11.168 11.168,4 20,4 Z M25.776,14.144 C24.064,14.144 22.672,15.52 22.688,17.232 C22.688,18.944 24.064,20.32 25.776,20.32 C27.488,20.32 28.864,18.944 28.864,17.232 C28.864,15.52 27.488,14.144 25.776,14.144 Z M16.176,11.616 C14.08,11.616 12.4,13.296 12.4,15.392 C12.4,17.472 14.096,19.168 16.176,19.168 C18.256,19.168 19.952,17.472 19.952,15.392 C19.952,13.312 18.256,11.616 16.176,11.616 Z M16.176,26.224 C16.176,25.168 16.592,23.328 19.216,21.936 C18.096,21.712 17.024,21.584 16.176,21.584 C13.824,21.584 9.632,22.496 7.952,24.288 C9.296,28.064 12.336,31.024 16.176,32.224 L16.176,26.224 Z M20,32.8 C25.424,32.8 30.048,29.408 31.92,24.656 C30.448,23.44 27.488,22.816 25.776,22.816 C23.44,22.816 18.736,23.952 18.736,26.224 L18.736,32.736 C19.152,32.784 19.568,32.8 20,32.8 Z"
      });
    }
  }));
};
UserCircle.defaultProps = {
  color: null
};
var _default = exports["default"] = UserCircle;
var name = exports.name = 'UserCircle';
var availableProps = exports.availableProps = ['color'];